"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M9.99988 12C8.89688 12 7.99988 11.103 7.99988 9.99996C7.99988 8.89696 8.89688 7.99996 9.99988 7.99996C11.1029 7.99996 11.9999 8.89696 11.9999 9.99996C11.9999 11.103 11.1029 12 9.99988 12ZM17.5799 7.39296C16.7919 4.94796 14.7959 3.02396 12.3239 2.32696C6.09188 0.568956 0.526881 6.17096 2.35188 12.409C3.07088 14.868 5.00588 16.85 7.45288 17.606C8.89688 18.054 10.3099 18.104 11.6069 17.838C11.8389 17.791 11.9999 17.58 11.9999 17.345V16.432C11.9999 16.009 11.7119 15.76 11.4069 15.833C10.3279 16.094 9.13588 16.062 7.91988 15.647C6.24688 15.078 4.90488 13.729 4.34288 12.052C2.65088 7.01296 7.50688 2.39496 12.5669 4.53796C13.8329 5.07396 14.8359 6.03796 15.3989 7.29196C16.1159 8.88696 16.1499 10.461 15.7089 11.825C15.6759 11.93 15.5789 12 15.4699 12H14.3519C14.1109 12 13.9999 11.888 13.9999 11.75V6.49996C13.9999 6.22396 13.7759 5.99996 13.4999 5.99996H12.4999C12.2239 5.99996 11.9999 6.22396 11.9999 6.49996V6.55496C11.0889 6.02396 9.97188 5.80996 8.76488 6.19896C7.41588 6.63396 6.35588 7.79096 6.08088 9.18196C5.57188 11.749 7.52288 14 9.99988 14C10.7319 14 11.4089 13.789 11.9999 13.445V13.5C11.9999 13.776 12.2239 14 12.4999 14H16.2859C16.6839 14 17.0419 13.767 17.2019 13.403C17.3889 12.978 17.6209 12.419 17.7189 12.056C18.1039 10.622 18.1089 9.03396 17.5799 7.39296Z",
    fill: "#727B7F"
  }));
};